import React, {useEffect, useState} from 'react'
import './ProfileDesign.css'
import {GenericProfileSegmentComponent} from "./profile-design/GenericProfileSegmentComponent";
import {getReportResource, getResource} from "../service/http-service";
import EducationIcon from '../../assets/img/profile-images/Obrazovanie-icon.png'
import FieldsIcon from '../../assets/img/profile-images/PolinjaNaInteres-icon.png'
import ExperienceIcon from '../../assets/img/profile-images/RabotnoIskustvo-icon.png'
import LanguagesIcon from '../../assets/img/profile-images/StranskiJazici-icon.png'
import AdditionalQualificationsIcon from '../../assets/img/profile-images/DopolnitelnaEdukacija-icon.png'
import ScientificPapers from '../../assets/img/profile-images/NaucniTrudovi-icon.png'
import ItSkillsIcon from '../../assets/img/profile-images/KompjuterskiVestini-icon.png'
import SkillsIcon from '../../assets/img/profile-images/Vestini-icon.png'
import DocumentsIcon from '../../assets/img/profile-images/Dokumenti-icon.png'
import AdditionalInformationIcon from '../../assets/img/profile-images/Preferenci-icon.png'
import HeaderImage from '../../assets/img/profile-images/profile-header.png'
import {Link} from "react-router-dom";
import fileDownload from "js-file-download";

export const ProfileDesignPreview = () => {

    const [candidate, setCandidate] = useState({});
    const [updateCandidate, setUpdateCandidate] = useState(false);
    const [candidateRecruitmentsList, setCandidateRecruitmentsList] = useState([])


    const getCandidate = () => {
         getResource('candidates/get_logged_user_candidate').then(data => {
             setCandidate(data.data);
         })}
    const getAppliedRecruitments = () => {
        getResource('candidates/get_applied_recruitment_for_logged_user').then((data) => {
            setCandidateRecruitmentsList(data.data)
        })
    }
    const generateCV = () => {
        getReportResource('generate_cv_for_logged_user').then(data => {
            fileDownload(data.data, "cv.pdf")
        })
    }
    useEffect(()=> {
        getCandidate();
        getAppliedRecruitments();
    },[])

    useEffect(()=> {
        getCandidate();
    },[updateCandidate])

    return (
       <div className="row m-0 p-0">
           <div className="col-12 m-0 p-0 position-relative">
               <img className="header_image" src={HeaderImage}/>
               <div className="username col-md-10 offset-md-1">
                   <p>кориснички профил</p>
                   <h2>{candidate.firstName} {candidate.lastName}</h2>
               </div>
           </div>
           <div className="row m-0 p-0">
               <div className='col-md-10 offset-md-1 p-0'>
                   {(candidate && candidate.id) && (
                       <div className="row m-0 p-0 profile_design_parent">
                           {(candidate.consentForDataProcessingForOneAd && (!candidateRecruitmentsList || candidateRecruitmentsList.length < 1)) &&
                               <small className="profileErrorText text-danger">Доколку не аплицирате на оглас во рок од 10 дена вашиот профил ќе биде избришан!</small>}
                           <div className="col-12 col-md-3 personal_info p-md-0">
                               <GenericProfileSegmentComponent candidate={candidate}
                                                               isPreview={true} type='PERSONAL_INFORMATION'
                                                               title="Лични податоци"
                                                               setCandidate={updateCandidate}
                                                               updateCandidate={updateCandidate}
                                                               setUpdateCandidate={setUpdateCandidate}
                               />
                               <Link to="/career_opportunities/profile" className="link-back">
                                   <div className="profile_add_button personal_info_button">Ажурирај профил</div>
                               </Link>
                               <div className="profile_add_button personal_info_button mt-3" onClick={() => generateCV()} >
                                   Зачувај CV во Pdf формат
                               </div>
                           </div>
                           <div className="col-12 col-md-8 content-profile">
                               <GenericProfileSegmentComponent candidate={candidate}
                                                               isPreview={true} type='EDUCATION'
                                                               title="Образование"
                                                               iconImage={EducationIcon}/>
                               <GenericProfileSegmentComponent candidate={candidate}
                                                               isPreview={true} type='FIELD_OF_INTEREST'
                                                               title="Полиња на интерес"
                                                               iconImage={FieldsIcon}/>
                               <GenericProfileSegmentComponent candidate={candidate}
                                                               isPreview={true} type='EXPERIENCE'
                                                               title="Работно искуство"
                                                               iconImage={ExperienceIcon}/>
                               <GenericProfileSegmentComponent candidate={candidate}
                                                               isPreview={true} type='LANGUAGE'
                                                               title="Странски јазици"
                                                               iconImage={LanguagesIcon}/>
                               <GenericProfileSegmentComponent candidate={candidate}
                                                               isPreview={true}
                                                               type='ADDITIONAL_QUALIFICATION'
                                                               title="Дополнителна едукација"
                                                               iconImage={AdditionalQualificationsIcon}/>
                               <GenericProfileSegmentComponent candidate={candidate}
                                                               isPreview={true}
                                                               type='SCIENTIFIC_PAPER'
                                                               title="Научни трудови"
                                                               iconImage={ScientificPapers}/>
                               <GenericProfileSegmentComponent candidate={candidate}
                                                               isPreview={true} type='IT_SKILL'
                                                               title="Компјутерски вештини"
                                                               iconImage={ItSkillsIcon}/>
                               <GenericProfileSegmentComponent candidate={candidate}
                                                               isPreview={true} type='SKILL'
                                                               title="Останати вештини"
                                                               iconImage={SkillsIcon}/>
                               <GenericProfileSegmentComponent candidate={candidate}
                                                               isPreview={true} type='DRIVING_LICENSE'
                                                               title="Возачки дозволи"
                                                               iconImage={AdditionalInformationIcon}/>
                               <GenericProfileSegmentComponent candidate={candidate}
                                                               isPreview={true} type='DOCUMENT'
                                                               title="Документи (мотивационо писмо, сертификати, дипломи, препораки)"
                                                               iconImage={DocumentsIcon}
                                                               updateCandidate={updateCandidate}
                                                               setUpdateCandidate={setUpdateCandidate}/>
                               <GenericProfileSegmentComponent candidate={candidate}
                                                               isPreview={true}
                                                               type='ADDITIONAL_INFORMATION'
                                                               title="Преференци"
                                                               iconImage={AdditionalInformationIcon}
                                                               updateCandidate={updateCandidate}
                                                               setUpdateCandidate={setUpdateCandidate}/>
                           </div>
                       </div>
                   )
                   }
                   <hr className="profile-footer-hr"/>
                   <div className="p-0 m-0 d-flex justify-content-end">
                      <div className="col-12 col-md-6 col-lg-3">
                          <Link to="/career_opportunities/published" className="link-back">
                              <div className="back-profile-btn"><i className='fa fa-angle-left'/>Назад кон листата на огласи</div>
                          </Link>
                      </div>
                   </div>
               </div>
           </div>
       </div>
    )
}